import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { getColor, responsive } from "~/helpers/style";

export const Container = styled.div`
  display: none;
  height: 64px;
  left: 0;
  z-index: 20;
  width: 100%;
  position: fixed;
  overflow-x: auto;
  bottom: 0;
  background-color: ${getColor("white")};
  box-shadow: 0px -12px 24px 0px rgba(8, 31, 64, 0.12);
  padding: 0 10px 0 8px;

  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  ${responsive("mobileXL", true)} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    flex-wrap: nowrap;
  }

  /* Extra small devices (320px and up) */
  @media (max-width: 374px) {
    padding: 0 8px 0 6px;
    gap: 4px;
  }

  /* Small devices (375px - 424px) */
  @media (min-width: 375px) and (max-width: 424px) {
    padding: 0 9px 0 7px;
    gap: 5px;
  }

  /* Medium devices (425px - 440px) */
  @media (min-width: 425px) and (max-width: 440px) {
    padding: 0 10px 0 8px;
    gap: 6px;
  }

  /* Larger devices (441px and up) */
  @media (min-width: 441px) {
    padding: 0 12px 0 10px;
    gap: 8px;
  }
`;

type MenuButtonProps = {
  activeColorIcon: boolean;
  activeclassname: string;
};

export const MenuButton = styled(NavLink)<MenuButtonProps>`
  width: 100%;
  margin: 0 5px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none;
  padding: 8px 4px;
  transition: all 0.2s ease;

  /* Extra small devices (320px and up) */
  @media (max-width: 374px) {
    flex: 0 0 auto;
    width: auto;
    min-width: calc(33.333% - 3px);
    gap: 4px;
    padding: 8px 3px;
  }

  /* Small devices (375px - 424px) */
  @media (min-width: 375px) and (max-width: 424px) {
    flex: 0 0 auto;
    width: auto;
    min-width: calc(33.333% - 3.5px);
    gap: 5px;
    padding: 8px 3px;
  }

  /* Medium devices (425px - 440px) */
  @media (min-width: 425px) and (max-width: 440px) {
    flex: 0 0 auto;
    width: auto;
    min-width: calc(33.333% - 4px);
    gap: 6px;
    padding: 8px 4px;
  }

  /* Larger devices (441px and up) */
  @media (min-width: 441px) {
    flex: 0 0 auto;
    width: auto;
    min-width: calc(33.333% - 5px);
    gap: 8px;
    padding: 8px 5px;
  }

  p {
    color: ${getColor("text")};
    white-space: nowrap;
    margin: 0;
  }

  svg {
    color: ${getColor("text")};
    flex-shrink: 0;
  }

  &.active {
    svg {
      color: ${getColor("primary")};
    }

    span {
      display: block;
    }

    p {
      color: ${getColor("primary")};
      font-weight: 700;
    }
  }

  :hover,
  :active,
  :focus {
    text-decoration: none;
  }
`;

export const ActiveBorder = styled.span`
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: ${getColor("primary")};
`;

export const BottomMenuImg = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;

  /* Extra small devices */
  @media (max-width: 374px) {
    width: 18px;
    height: 18px;
  }

  /* Medium devices (425px - 440px) */
  @media (min-width: 425px) and (max-width: 440px) {
    width: 21px;
    height: 21px;
  }

  /* Larger devices (441px and up) */
  @media (min-width: 441px) {
    width: 22px;
    height: 22px;
  }
`;

export const BottomMenuText = styled.p`
  color: ${getColor("primary")};
  font-family: Nunito, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0.02px;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;

  /* Extra small devices (320px - 374px) */
  @media (max-width: 374px) {
    font-size: 11px;
  }

  /* Small devices (375px - 424px) */
  @media (min-width: 375px) and (max-width: 424px) {
    font-size: 12px;
  }

  /* Medium devices (425px - 440px) */
  @media (min-width: 425px) and (max-width: 440px) {
    font-size: 13px;
  }

  /* Larger devices (441px and up) */
  @media (min-width: 441px) {
    font-size: 14px;
  }
`;

type AlertCircleProps = {
  top: number;
  right: number;
};

export const AlertCircle = styled.span<AlertCircleProps>`
  position: absolute;
  z-index: 1;
  top: ${(props) => `${props.top}px`};
  right: ${(props) => `calc(50% - ${props.right}px)`};
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${getColor("primary")};
  border: 1.5px solid ${getColor("white")};

  /* Extra small devices */
  @media (max-width: 374px) {
    width: 5px;
    height: 5px;
    border: 1px solid ${getColor("white")};
  }

  /* Medium devices */
  @media (min-width: 425px) {
    width: 7px;
    height: 7px;
    border: 2px solid ${getColor("white")};
  }
`;
